// Senha forte obrigatória para admin/funcionário (pedido 2026-09-23).
// Espelho de gpsdrive-backend/src/auth/password-policy.ts — mudar nos dois
// lugares. Clientes ("usuario") continuam livres (mantêm o 123456, pedido
// explícito).
export const STRONG_PASSWORD_ACCOUNT_TYPES = ["admin", "funcionario"];
export const MIN_STRONG_PASSWORD_LENGTH = 8;

export const STRONG_PASSWORD_RULES: { label: string; test: (p: string) => boolean }[] = [
  { label: `Pelo menos ${MIN_STRONG_PASSWORD_LENGTH} caracteres`, test: (p) => p.length >= MIN_STRONG_PASSWORD_LENGTH },
  { label: "Uma letra maiúscula", test: (p) => /[A-Z]/.test(p) },
  { label: "Uma letra minúscula", test: (p) => /[a-z]/.test(p) },
  { label: "Um número", test: (p) => /[0-9]/.test(p) },
  { label: "Um caractere especial (! @ # $ % …)", test: (p) => /[^A-Za-z0-9]/.test(p) },
];

export function requiresStrongPassword(accountType: string | null | undefined): boolean {
  return STRONG_PASSWORD_ACCOUNT_TYPES.includes(accountType ?? "");
}

export function isStrongPassword(p: string): boolean {
  return STRONG_PASSWORD_RULES.every((r) => r.test(p));
}

// Mensagem pronta pra toast/erro inline, ou null se a senha serve.
export function passwordPolicyError(accountType: string | null | undefined, p: string): string | null {
  if (!requiresStrongPassword(accountType)) return null;
  const missing = STRONG_PASSWORD_RULES.filter((r) => !r.test(p)).map((r) => r.label.toLowerCase());
  return missing.length ? `A senha precisa ter: ${missing.join(", ")}.` : null;
}
